// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1lDWy","signatureButtonsRight":"ModalSign_signatureButtonsRight__3e6ea"};